import React, { useEffect, useMemo, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import "./SiteMap.css";

const makeFamilySlug = (value = "") => value.trim().toLowerCase().replace(/\s+/g, "-");

function SiteMap() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const snap = await getDocs(collection(db, "products"));
        setProducts(snap.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() })));
      } catch (error) {
        console.error("Could not load sitemap products:", error);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  const productFamilies = useMemo(() => {
    const grouped = {};

    products.forEach((product) => {
      const family = product.productFamily?.trim() || "Other";
      if (!grouped[family]) grouped[family] = [];
      grouped[family].push(product);
    });

    return Object.entries(grouped)
      .map(([family, familyProducts]) => ({
        family,
        products: familyProducts.sort((a, b) => (a.product || a.name || a.id).localeCompare(b.product || b.name || b.id)),
      }))
      .sort((a, b) => a.family.localeCompare(b.family));
  }, [products]);

  return (
    <div className="sitemap-page">
      <div className="sitemap-header">
        <h1>Site Map</h1>
        <p>Explore Go!Foton products, solutions, resources, and company information.</p>
      </div>

      <div className="sitemap-main-links">
        <div className="sitemap-link-group">
          <h2>Company</h2>
          <a href="/about">About Us</a>
          <a href="/leadership">Leadership</a>
          <a href="/news">News & Events</a>
          <a href="/careers">Careers</a>
          <a href="/contact-us">Contact Us</a>
        </div>

        <div className="sitemap-link-group">
          <h2>Solutions</h2>
          <a href="/solutions">All Solutions</a>
          <a href="/solutions/ai">AI</a>
          <a href="/solutions/datacenter">Data Center</a>
          <a href="/solutions/central-office">Central Office & Headend</a>
          <a href="/solutions/outside-plant">Outside Plant</a>
          <a href="/solutions/fttx">FTTx & MDU</a>
          <a href="/solutions/rural-broadband">Rural Broadband</a>
          <a href="/solutions/wireless">Wireless</a>
          <a href="/solutions/enterprise">Enterprise</a>
          <a href="/solutions/medical-imaging">Medical Imaging</a>
          <a href="/solutions/neuroscience">Neuroscience</a>
          <a href="/solutions/specialty-optics">Specialty Optics</a>
        </div>

        <div className="sitemap-link-group">
          <h2>Resources</h2>
          <a href="/knowledge-center">Knowledge Center</a>
          <a href="/bead">BEAD & BABA</a>
          <a href="/partners">Partners</a>
          <a href="/part-lookup">Part Number Lookup</a>
          <a href="/events">Trade Shows & Events</a>
        </div>

        <div className="sitemap-link-group">
          <h2>Services</h2>
          <a href="/services">All Services</a>
        </div>
      </div>

      <section className="sitemap-products">
        <div className="sitemap-products-heading">
          <h2>Products</h2>
          <a href="/products">View All Products</a>
        </div>

        {loading ? (
          <p className="sitemap-loading">Loading products...</p>
        ) : (
          <div className="sitemap-family-grid">
            {productFamilies.map(({ family, products: familyProducts }) => (
              <div className="sitemap-family" key={family}>
                <h3><a href={`/${makeFamilySlug(family)}`}>{family}</a></h3>
                <div className="sitemap-product-list">
                  {familyProducts.map((product) => {
                    const slug = product.slug || product.id;
                    const name = product.product || product.name || product.id;
                    return <a href={`/${slug}`} key={slug}>{name}</a>;
                  })}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default SiteMap;